import { Component } from '@angular/core';

@Component({
  selector: 'via-infographics',
  templateUrl: './infographics.component.html',
  styleUrls: ['./infographics.component.scss']
})
export class InfographicsComponent {
}
